import { CUSTOMERS_LOADED, LOAD_CUSTOMERS, RESET_CUSTOMERS, SYNC_FAILED } from './actionTypes';

export const initialState = {
  error: null,
  loaded: false,
  customers: [],
  loading: false,
};

export const reducer = (state = initialState, action: { type: any; payload?: any }) => {
  switch (action.type) {
    case LOAD_CUSTOMERS:
      return { ...state, error: null, loading: true };
    case CUSTOMERS_LOADED:
      return {
        ...state,
        error: null,
        customers: action.payload,
        loading: false,
        loaded: true,
      };

    case RESET_CUSTOMERS:
      return initialState;
    case SYNC_FAILED:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
